import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { CustomAvatar } from "./CustomAvatar";
import messages from '../user-messages/home.json'
export const CustomNavbar = () => {
    return (
        <Box>
            <AppBar position="static">
                <Toolbar>
                    <CustomAvatar
                        sx={{
                            color: '#1976d2',
                            backgroundColor: 'white',
                            margin:'15px 5px'
                        }}>A</CustomAvatar>
                    <Typography style={{
                        fontSize: 'x-large',
                        margin: '10px 40px'
                    }}>{messages.artyaSoftwares}</Typography>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
